import { defineComponent as _defineComponent } from 'vue'
import RoccSeverityEditor from '@/_legacy/views/ChecklistBuilder/Build/Components/RoccSeverityEditor.vue';
  import { CheckboxField } from '@/ui/components/form';
  import { Tooltip } from '@/ui/components/Tooltip';
  import { LegacyItem, LegacyRoccSeverity } from '@/ui/components/inspectionReport/legacyTypes';
  import { computed, getCurrentInstance } from 'vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryScoring',
  setup(__props) {

  const instance = getCurrentInstance();
  const store = instance!.proxy.$store;

  const checklist = computed(() => store.getters['checklist_builder/checklist']);
  const categories = computed(() => store.getters['checklist_builder/categories']);
  const pages = computed<LegacyItem[]>(() => store.getters['checklist_builder/pages']);

  const roccEnabled = computed(() => checklist.value?.form?.params?.rocc_enabled || false);
  const severities = computed<LegacyRoccSeverity[]>(() => checklist.value?.form?.params?.severities || []);

  const hasPageWithRoccEnabled = computed(() => {
    return pages.value?.some(page => page.params?.rocc_enabled) || false;
  });

  const handleRoccEnabledUpdate = (value: boolean) => {
    store.commit('checklist_builder/setFormRoccSettings', {
      roccEnabled: value,
      severities: value ? [{ category: null, threshold: 1 }] : [],
    });
  };

  const handleSeveritiesUpdate = (value: LegacyRoccSeverity[]) => {
    store.commit('checklist_builder/setFormRoccSettings', {
      severities: value,
    });
  };

return { __sfc: true,instance, store, checklist, categories, pages, roccEnabled, severities, hasPageWithRoccEnabled, handleRoccEnabledUpdate, handleSeveritiesUpdate, RoccSeverityEditor, CheckboxField, Tooltip }
}

})